import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table } from "@opensea/ui-kit";
import { CreateCollectionOfferFlowTableFragment } from "./CreateCollectionOfferFlowTable.fragment";
import { CreateCollectionOfferFlowTableHeader, CreateCollectionOfferFlowTableHeaderSkeleton } from "./CreateCollectionOfferFlowTableHeader";
import { CreateCollectionOfferFlowTableRow, CreateCollectionOfferFlowTableRowSkeleton } from "./CreateCollectionOfferFlowTableRow";
export const CreateCollectionOfferFlowTable = t0 => {
  const $ = _c(10);
  const {
    collection: collectionKey,
    isReview
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(CreateCollectionOfferFlowTableFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CreateCollectionOfferFlowTableHeader />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isReview) {
    t3 = {
      isReview
    };
    $[3] = isReview;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== collection) {
    t4 = [collection];
    $[5] = collection;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <>{t2}<Table className="shrink-0" context={t3} itemKey={_temp} items={t4} renderRow={CreateCollectionOfferFlowTableRow} size="md" /></>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const CreateCollectionOfferFlowTableSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CreateCollectionOfferFlowTableHeaderSkeleton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Table className="shrink-0" itemKey={_temp2} items={[0]} renderRow={CreateCollectionOfferFlowTableRowSkeleton} size="md" /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(collection_0) {
  return collection_0?.slug;
}
function _temp2(_, index) {
  return index;
}